// components/PgInquiryForm.jsx

import React, { useState } from "react";
import {
 Box,
 Button,
 Input,
 FormControl,
 FormLabel,
 Heading,
 VStack,
 useToast,
} from "@chakra-ui/react";
import Select from "react-select";
import axios from "axios";

const states = [
 "Karnataka",
 "Jammu and Kashmir",
 "Uttarakhand",
 "Arunachal Pradesh",
 "Meghalaya",
 "Himachal Pradesh",
 "Gujarat",
 "Assam",
 "Dadra and Nagar Haveli",
 "Kerala",
 "West Bengal",
 "Maharashtra",
 "Madhya Pradesh",
 "Delhi",
 "Rajasthan",
 "Bihar",
 "Sikkim",
 "Tamil Nadu",
 "Orissa",
 "Goa",
 "Andhra Pradesh",
 "Telangana",
 "Chhattisgarh",
 "Mizoram",
 "Punjab",
 "Jharkhand",
 "Uttar Pradesh",
];

const branchOptions = [
 "Radiology",
 "Dermatology",
 "General medicine",
 "Gynecology",
 "Orthopaedics",
 "Pediatrics",
 "ENT",
 "Opthal",
 "Anesthesia",
 "General Surgery",
 "Psychiatry",
 "Pathology",
 "Others",
];

const budgetOptions = [
 "Below 50 lakhs",
 "50-1 Cr",
 "1-1.5 Cr",
 "1.5-2.5 Cr",
 "3 Cr Plus",
];

const formatOptions = (arr) => arr.map((value) => ({ label: value, value }));

const PgInquiryForm = ({ onSuccess }) => {
 const [formData, setFormData] = useState({
  name: "",
  contactDetail: "",
  city: "",
  state: null,
  neetPgScore: "",
  branch: [],
  budget: null,
 });

 const toast = useToast();

 const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {
   ...formData,
   state: formData.state?.value,
   budget: formData.budget?.value,
   branch: formData.branch.map((b) => b.value),
  };

  try {
   await axios.post(
    "https://admission-backend-theta.vercel.app/api/pg-inquiries",
    payload
   );
   setFormData({
    name: "",
    contactDetail: "",
    city: "",
    state: null,
    neetPgScore: "",
    branch: [],
    budget: null,
   });
   onSuccess();
  } catch (error) {
   toast({
    title: "Error",
    description: "Failed to submit inquiry.",
    status: "error",
    duration: 6000,
    isClosable: true,
   });
  }
 };

 return (
  <Box maxW="600px" mx="auto" mt={10} p={6} borderWidth="1px" borderRadius="md">
   <Heading mb={6} textAlign="center" size="lg">
    PG Inquiry Form
   </Heading>
   <form onSubmit={handleSubmit}>
    <VStack spacing={4}>
     <FormControl isRequired>
      <FormLabel>Name</FormLabel>
      <Input
       value={formData.name}
       onChange={(e) => setFormData({ ...formData, name: e.target.value })}
       placeholder="Enter your name"
      />
     </FormControl>

     <FormControl isRequired>
      <FormLabel>Contact Detail</FormLabel>
      <Input
       value={formData.contactDetail}
       onChange={(e) =>
        setFormData({ ...formData, contactDetail: e.target.value })
       }
       placeholder="Phone or Email"
      />
     </FormControl>

     <FormControl isRequired>
      <FormLabel>City</FormLabel>
      <Input
       value={formData.city}
       onChange={(e) => setFormData({ ...formData, city: e.target.value })}
       placeholder="Enter your city"
      />
     </FormControl>

     <FormControl isRequired>
      <FormLabel>State</FormLabel>
      <Select
       options={formatOptions(states)}
       placeholder="Select State"
       value={formData.state}
       onChange={(val) => setFormData({ ...formData, state: val })}
      />
     </FormControl>

     <FormControl>
      <FormLabel>NEET PG Score</FormLabel>
      <Input
       type="number"
       value={formData.neetPgScore}
       onChange={(e) =>
        setFormData({ ...formData, neetPgScore: e.target.value })
       }
       placeholder="Optional"
      />
     </FormControl>

     <FormControl>
      <FormLabel>Preferred Branch(es)</FormLabel>
      <Select
       isMulti
       options={formatOptions(branchOptions)}
       placeholder="Select Branches"
       value={formData.branch}
       onChange={(val) => setFormData({ ...formData, branch: val })}
      />
     </FormControl>

     <FormControl isRequired>
      <FormLabel>Expected Budget</FormLabel>
      <Select
       options={formatOptions(budgetOptions)}
       placeholder="Select Budget"
       value={formData.budget}
       onChange={(val) => setFormData({ ...formData, budget: val })}
      />
     </FormControl>

     <Button type="submit" colorScheme="blue" width="full">
      Submit Inquiry
     </Button>
    </VStack>
   </form>
  </Box>
 );
};

export default PgInquiryForm;
